import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import { SOURCE_NAME } from './constants.tsx';
import ContactAdministratorUI from './ui/index.tsx';
import { METRICS_PAGE_ID, contactAdminPageLoad } from './utils/performance-analytics/index.tsx';

export default function ContactAdministrator() {
	return (
		<>
			<MarkProductStart />
			<JSErrorBoundary
				id="contactAdministrator"
				packageName="jiraAdminContactAmin"
				teamName="jira-notifications-platform"
			>
				<ContextualAnalyticsData sourceName={SOURCE_NAME} sourceType={SCREEN}>
					<ContactAdministratorUI />
					<SpaStatePageReady />
					{/* @ts-expect-error - TS2769 - No overload matches this call. */}
					<SubmitApdex appName={METRICS_PAGE_ID} metric={contactAdminPageLoad} />
					<FireScreenAnalytics />
				</ContextualAnalyticsData>
			</JSErrorBoundary>
		</>
	);
}
